import { Component, OnInit } from '@angular/core';
import { APPCONFIG } from "../../../config";

@Component({
  selector: 'app-center-divider',
  templateUrl: './center-divider.component.html',
  styleUrls: ['./center-divider.component.scss']
})
export class CenterDividerComponent implements OnInit {
  AppConfig: any;

  constructor() { }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }

}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/ui/divier/center-divider/center-divider.component.ts